import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormConfigService } from 'src/app/form-config/form-config.service';
import { UiKitModule } from 'src/app/ui-kit/ui-kit.module';
import { FilterEntitiesPipe } from './pipes/filter-entities.pipe';
import { ReferenceEntitiesComponent } from './reference-entities/reference-entities.component';
import { ReferenceModalComponent } from './reference-modal.component';
import { ReferenceModalService } from './reference-modal.service';

@NgModule({
  declarations: [
    ReferenceModalComponent,
    ReferenceEntitiesComponent,
    FilterEntitiesPipe
  ],
  imports: [
    CommonModule,
    NgbModule,
    UiKitModule,
    FormsModule,
    FontAwesomeModule,
    ReactiveFormsModule
  ],
  providers: [
    ReferenceModalService,
    FormConfigService,
  ],
})
export class ReferenceModalModule { }
